{ "imageTag": "20261104124821_4c0cfda", "buildUri": "vstfs:///Build/Build/104120", "buildId": "104120", "sourceCommit": "4c0cfdad7f111d51c4e58ccf88fc109157bd481b", "sourceBranch": "main", "releaseDate": "2026-11-04T12:52:13Z" }
